import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

import { SharedModule } from 'v2/modules/shared/shared.module';
import { FeatureModule } from 'v2/shared/feature/feature.module';
import { SharedComponentsModule } from 'v2/shared-components.module';

import { CostLayerComponent } from './components/cost-layer/cost-layer.component';
import { CostLayerChangesAgCellSummaryComponent } from './components/cost-layer-changes-ag-cell-summary/cost-layer-changes-ag-cell-summary.component';
import { CostLayerChangesAgCellTransactionComponent } from './components/cost-layer-changes-ag-cell-transaction/cost-layer-changes-ag-cell-transaction.component';
import { CostLayerChangesDumbLogComponent } from './components/cost-layer-changes-dumb-log/cost-layer-changes-dumb-log.component';
import { CostLayerEditComponent } from './components/cost-layer-edit/cost-layer-edit.component';
import { CostLayerInfoComponent } from './components/cost-layer-info/cost-layer-info.component';
import { CostLayerUnitCostCellEditorComponent } from './components/cost-layer-unit-cost-cell-editor/cost-layer-unit-cost-cell-editor.component';
import { CostLayersBasicTableComponent } from './components/cost-layers-basic-table/cost-layers-basic-table.component';
import { CostLayersComponent } from './components/cost-layers.component';
import { CostLayersRoutingModule } from './cost-layers.routing';

@NgModule({
  declarations: [
    CostLayersComponent,
    CostLayersBasicTableComponent,
    CostLayerComponent,
    CostLayerEditComponent,
    CostLayerInfoComponent,
    CostLayerUnitCostCellEditorComponent,
    CostLayerChangesDumbLogComponent,
    CostLayerChangesAgCellTransactionComponent,
    CostLayerChangesAgCellSummaryComponent,
  ],
  exports: [CostLayersBasicTableComponent, CostLayerUnitCostCellEditorComponent],
  imports: [
    AgGridModule,
    CommonModule,
    CostLayersRoutingModule,
    FeatureModule,
    FormsModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    RouterModule,
    SharedComponentsModule,
    SharedModule,
  ],
})
export class CostLayersModule {}
